<template>
  <div>
  <div class="header">
    <i v-show="!isPC" @click="onIconMore" class="el-icon-more"></i>
    <el-drawer  size="80%"  :withHeader="false"  direction="ltr" :visible.sync="drawer">
      <Menu @selectMenu="selectMenu"></Menu>
    </el-drawer>
    <div class="image-box">
      <img class="logo-img" src="@/assets/images/logo.png" />
      Welcome to Online Application System
    </div>
    <div class="awesome">
      <div v-if="isPC" class="awesome-user">
        <img src="@/assets/images/Iconawesome-user.png" />
        <span class="awesome-user-text">{{ userInfoName }}</span>
      </div>
      <div :class="{'userinfo-cursor-pc': !isPC}"  class="userinfo" @click="onLogoutClick">
        <span  class="userinfo-cursor">Logout</span>
        <img v-if="isPC" src="@/assets/images/Iconopen-account-logout.png" />
      </div>
    </div>
  </div>
   <loadingDialog :centerDialogVisible="loadingDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog";
import Menu from "./Menu";
import { logout } from "@/api/security";
import { removeToken, removeAll, getUserInfo } from "@/utils/auth";
export default {
  components:{Menu,loadingDialog},
  data() {
    return {
      loadingDialogVisible:false,
      drawer:false,
      userInfoName: getUserInfo(`userInfo/${this.$store.getters.authorityRoute}`)?.email || '',
    };
  },
  computed:{
    isPC(){
      return this.$store.getters.isPC
    }
  },
  methods: {
    selectMenu(){
      this.drawer =false
    },
    onIconMore(){
      this.drawer = !this.drawer
    },
    onUserName() {
      this.$router.push({ path: "/personalInformation" });
    },
    onLogoutClick() {
      this.loadingDialogVisible = true;
      this.logout();
    },
    logout() {
      let from = {
        refreshToken: getUserInfo(`userInfo/${this.$store.getters.authorityRoute}`).refreshToken,
      };
      logout(from).then(() => {
        removeToken(this.$store.getters.authorityRoute);
        removeAll();
        location.reload();
      }).finally(() => {
        this.loadingDialogVisible = false;
      });
    },
  },
};
</script>

<style lang="scss"  scoped>
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 6.0625rem;
  padding-left: 2.125rem;
  background-color: #060c60;
  color: #fff;
  box-shadow: 1px 6px 8px rgba(0, 0, 0, 0.16);
}
.logo {
  display: flex;
  align-items: center;
}
.image-box {
  display: flex;
  align-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.875rem;
  padding: 1.25rem;
}
.logo-img {
  display: block;
  height: 4.5rem;
  margin-right: 1.25rem;
}
.logo-text {
  font-size: 1.25rem;
  font-weight: bold;
}
.userinfo {
  display: flex;
  font-size: 1.25rem;
  align-items: center;
}
.userinfo-button,
.userinfo-divider,
.userinfo-text {
  margin: 0 1.25rem;
}
.userinfo-button {
  border: 3px solid #fff;
}
.userinfo-cursor {
  cursor: pointer;
  padding-right: 1.25rem;
}

.awesome {
  display: flex;
  align-items: center;
  height: 100%;
}
.awesome-user {
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 1.25rem;
  cursor: pointer;
  .awesome-user-text {
    margin-left: 0.625rem;
    font-size: 1.125rem;
    font-weight: bolder;
  }
}

.userinfo {
  display: flex;
  font-size: 1.25rem;
  align-items: center;
  background-color: #0092d2;
  height: 100%;
  padding: 0 1.25rem;
  cursor: pointer;
}
.userinfo-cursor-pc{
  // 背景色透明
  background-color: transparent;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
.image-box{
  font-size: 1rem;
  padding: 0.625rem;
}
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
.image-box{
  font-size: 1rem;
  padding: 0.625rem;
}
.el-icon-more{
  display: block !important;
}
}
</style>
